import React, { useEffect } from 'react'
import Modal from 'react-modal'
import s from './Dialog.module.scss'
import { lockBody, unlockBody } from './bodyScroll'

export const Spinner = () => <div className={s.spin} />

const Dialog = ({ isOpen, onClose, title, subtitle, className, children }) => {
  useEffect(() => {
    if (!isOpen) return undefined
    lockBody()
    return unlockBody
  }, [isOpen])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      overlayClassName={s.overlay}
      className={className ? `${s.dialog} ${className}` : s.dialog}
    >
      <div className={s.head}>
        <h3>{title}</h3>
        {subtitle && <div className={s.sub}>{subtitle}</div>}
      </div>
      <div className={s.body}>{children}</div>
      <div className={s.foot}>
        <button type='button' onClick={onClose}>
          Закрыть
        </button>
      </div>
    </Modal>
  )
}

export default Dialog
